import React, { useEffect } from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import ProductDetailsTwo from "../components/ProductDetailsTwo";
import NewArrivalTwo from "../components/NewArrivalTwo";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterTwo from "../components/Footer";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductDetailsData } from "../features/product_details/productDetailsSlice";
import { useParams } from "react-router-dom";

const ProductDetailsPageTwo = () => {
  const {slug} = useParams();
  const dispatch = useDispatch();
  const {product_details, loading, error} = useSelector((state) => state.product_details)

  useEffect(() => {
    if (!slug) return;

    dispatch(fetchProductDetailsData(slug))
  }, [slug])

  return (
    <>
      {
        loading ? (
          <> 
            <ColorInit color={true} />
            <ScrollToTop smooth color="#FA6400" />
            <Preloader />
          </>
        ) : (
          <> 
            <Breadcrumb title={"Product Details"} />
            <ProductDetailsTwo product_details={product_details} />
            <NewArrivalTwo />
            <ShippingOne />
            <NewsletterOne />
          </>
        )
      }
    </>
  );
};

export default ProductDetailsPageTwo;
